import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { EmailFields } from "./components/EmailFields";
import { useI18n } from '@/hooks/useI18n';
import { Info } from "lucide-react";

interface SendQuoteStep2EmailProps {
    sendEmail: boolean;
    /** Cliente non ancora attivo: la mail porta le credenziali, non si puo' deselezionare. */
    isEmailRequired: boolean;
    onSendEmailChange: (value: boolean) => void;
    emailSubject: string;
    customMessage: string;
    onEmailSubjectChange: (value: string) => void;
    onCustomMessageChange: (value: string) => void;
    subjectPlaceholder: string;
}

export const SendQuoteStep2Email = ({
    sendEmail,
    isEmailRequired,
    onSendEmailChange,
    emailSubject,
    customMessage,
    onEmailSubjectChange,
    onCustomMessageChange,
    subjectPlaceholder,
}: SendQuoteStep2EmailProps) => {
    const { t } = useI18n();

    return (
        <div className="space-y-6">
            {/* Send Email Checkbox */}
            <div className="flex items-start space-x-3 p-4 border rounded-lg bg-gray-50">
                <Checkbox
                    id="send-email"
                    checked={sendEmail}
                    onCheckedChange={(v) => onSendEmailChange(v === true)}
                    disabled={isEmailRequired}
                    className="mt-0.5"
                />
                <div className="flex-1">
                    <Label
                        htmlFor="send-email"
                        className={`text-sm font-medium ${isEmailRequired ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                        {t('itinerary.sendEmailToClient') || 'Send email to client'}
                    </Label>
                    <p className="text-xs text-gray-500 mt-1 flex items-start gap-1">
                        <Info className="h-3 w-3 mt-0.5 flex-shrink-0" />
                        <span>
                            {isEmailRequired
                                ? t('itinerary.sendEmailRequiredDescription')
                                : t('itinerary.sendEmailDescription')}
                        </span>
                    </p>
                </div>
            </div>

            {/* Email Fields - visible only when sendEmail is true */}
            {sendEmail && (
                <div className="space-y-4 animate-in fade-in duration-300">
                    <EmailFields
                        emailSubject={emailSubject}
                        customMessage={customMessage}
                        onEmailSubjectChange={onEmailSubjectChange}
                        onCustomMessageChange={onCustomMessageChange}
                        subjectPlaceholder={subjectPlaceholder}
                    />
                </div>
            )}

            {/* Senza mail: il cliente trova la proposta solo accedendo */}
            {!sendEmail && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 animate-in fade-in duration-300">
                    <div className="flex items-start gap-2">
                        <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <div className="text-sm text-blue-900">
                            <p className="font-medium mb-1">
                                {t('itinerary.manualSendingTitle')}
                            </p>
                            <p className="text-blue-700">
                                {t('itinerary.manualSendingInfo')}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
